/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import RenderSections from '@msr/Common/RenderSections';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const WatchOnTvLang = ({ pageData, lang }) => {
  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={''}
        lang={lang}
      />

      <Box
        as="section"
        className="container-article"
        p="0"
        bg="#03062C"
      >
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value.map((section, i) => {
              return (
                <RenderSections pageData={pageData}
                  section={section}
                  region={''}
                  lang={lang}
                  key={nanoid(4)}
                />
              );
            })
          : null}
      </Box>
      <PageConfig
        isLikeVisible={false} pageData={pageData}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
        `/mahashivratri/ta/participate/tv-channels`,
        `/mahashivratri/hi/participate/tv-channels`
      ]
    : await getLandingPaths('L2', '/participate/tv-channels');
  return {
    paths: msrPaths,
    fallback: false
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { lang }
}) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', lang, 'msr'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('', lang, 'msr'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', lang, 'participate/tv-channels', {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      lang: lang,
      menuType: 'msrmainmenu'
    }
  };
};

export default WatchOnTvLang;
